import React, { Component } from "react";
import HeaderNew from "./HeaderNew";
import FooterNew from "./FooterNew";
import Footer from "../Copyrights/Footer";
import BackArrow from "./../../../public/assets/images/back-arrow-dark.svg";
import Chart from "./../../../public/assets/images/chart-image.png";
import MiniArrow from "./../../../public/assets/images/mini-arrow.svg"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import $ from 'jquery';
import { getPlan } from '../../API/FetchCall';

import icon1 from "./../../../public/assets/newpage/icon1.png";
import icon2 from "./../../../public/assets/newpage/icon2.png";
import icon3 from "./../../../public/assets/newpage/icon3.png";
import icon4 from "./../../../public/assets/newpage/icon4.png";

import sampleview1 from "../../assets/images/view1.png";
import sampleview2 from "../../assets/images/view2.png";
import sampleview3 from "../../assets/images/view3.png";

import step1 from "../../assets/images/icons/signup.png";
import step2 from "../../assets/images/icons/cash-on-delivery.png";
import step3 from "../../assets/images/icons/approve.png";
import step4 from "../../assets/images/icons/launch.png";

import instutionalBG from "../../assets/images/bannerbg.png";

var CurrencyFormat = require('react-currency-format');

import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';


class PlanPageSchools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan_list2: [],
      clickedfromwc: this.props.match.params.wc ? true : false,
      current_plan: []
    };

    //this.cwc = this.props.match.params.wc ? this.props.match.params.wc : '';
     
    this.getPlanList();
    this.slideCustom = React.createRef();
    this.slidepackages = React.createRef();
    this.slideCustom3 = React.createRef();
  }


  componentDidMount() {
    let logged = localStorage.getItem("authentication");
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    console.log('auth_data.role', logged);
    /*
    if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
      window.location.href = '/dashboard/dashboard';
    } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
      window.location.href = '/partner/profile';
    }
    */

    if(this.state.clickedfromwc){
      var element = document.getElementById("wiseconnectpricing");
      element.scrollIntoView({behavior:"smooth", block: "start"});
    }

  }


  analyticsOffer = () => {
    this.setState({
      offerModal: false,
      analyticsModal: true,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToOffer = () => {
    this.setState({
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToSlide = () => {
    this.setState({
      offerModal: false,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").removeClass("in");
    }, 500);
  };

  getPlanList = async () => {
    let planData = JSON.stringify({
      user_type: 1,
    });

    getPlan(planData).then((response) => {
      if (response.status == 1) {
        this.setState({
          plan_list2: response.results,
        });

      } else {
        console.log('else')
      }
    });
  }

  showPrice1 = (e) =>{
    
    $("#showPrice1").html('INR 649*/- Per Month <br/> BeWise Pricing as applicable');

  }

  showPrice2 = (e) =>{
    
    $("#showPrice2").html('INR 1799*/- Per Month');

  }
  

  handlePlan = (id) => {
    let plan_info = this.state.plan_list2.filter(o => o.id == id);
    console.log('plan_info', plan_info)
    this.setState({
      current_plan: plan_info,
      plan_id: id,
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };


  analyticsOffer = () => {
    this.setState({
      offerModal: false,
      analyticsModal: true,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToOffer = () => {
    this.setState({
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToSlide = () => {
    this.setState({
      offerModal: false,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").removeClass("in");
    }, 500);
  };


  render() {


    var settings = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };



    var settings_dashboards = {

      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]

    };

    var packages_settings = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
      autoplay: false,
      autoplaySpeed: 5000
    };

    var packages_settings_mobile = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <React.Fragment>

       
        <HeaderNew />

        <div class="row display-flex-center mainrowheader" style={{ marginTop: "85px" }}>
          <div class="col-lg-2 col-sm-2 col-md-2">

          </div>
          <div class="col-lg-8 col-sm-8 col-md-8">

            <div class="bannersection">

              <div class="bheader">Welcome to <span className="bluetext">BeWise</span> Partner Program</div>

              <div class="bbg"><img src={instutionalBG} className="bannerbg" /></div>

              <div class="biconbox">

                <Slider {...settings} ref={this.slideCustom}>

                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon1} /></div>
                      <div class="info">
                        <h3 class="titlesm">Efficiency</h3>
                        <h4 class="subtitle">Reaching target audience continuosly with</h4>
                        <ul class="boxli">
                          <li>Brand recall</li>
                          <li>Returns</li>
                          <li>Reach</li>
                          <li>Talent access</li>
                          <li>Focus on objective</li>
                        </ul>
                      </div>
                    </div>
                    <div class="space"></div>
                  </div>


                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon2} /></div>
                      <div class="info">
                        <h3 class="titlesm">Engagement</h3>
                        <h4 class="subtitle">Continously with target Audience on</h4>
                        <ul class="boxli">
                          <li>Brand values</li>
                          <li>Leadership and followers</li>
                          <li>Attracking talent</li>
                          <li>Leveraging feedback</li>
                          <li>Reaching events beyond</li>

                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>


                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon3} /></div>
                      <div class="info">
                        <h3 class="titlesm">Excellence</h3>
                        <h4 class="subtitle">New Industry Standards</h4>
                        <ul class="boxli">
                          <li>Data based decisions</li>
                          <li>Transparency and leadership</li>
                          <li>Enrollments 24x7</li>
                          <li>Build insights and leadership for commnunity</li>
                          <li>Frequently showcase successes to attract the best</li>
                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>

                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon4} /></div>
                      <div class="info">
                        <h3 class="titlesm">Enable(ment)</h3>
                        <h4 class="subtitle">Raise Industry Standards</h4>
                        <ul class="boxli">

                          <li>Brand strength 24x7</li>
                          <li>Continuous benchmarking & tracking competitiveness</li>
                          <li>Connected with trends and quick to customize</li>
                          <li>Lead thought leadership for industry</li>
                          <li>Attracting talent continuously</li>

                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>

                </Slider>

              </div>
            </div>

            <div class="packagesection">

             

              <div class="planbox">

              <table class="pricing-table-box">
                <tbody>
                    <tr>
                        <td width="40%" class="pricing-table-box-text">
                            <h2>PRICING PLANS</h2>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head color2">
                                    <p>BeWise Standard</p>
                                </div>
                                <div class="pricing-table-box-item-price color2">
                                    <p><span>FREE</span></p>
                                </div>
                            </div>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head bewisemagic">
                                    <p>BeWise Magic</p>

                                </div>
                                <div class="pricing-table-box-item-price color2">
                                    <p><span>Annual Subscription Fee</span></p>

                                </div>

                            </div>
                        </td>
                         
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row bolder">24x 7 visibility and growth. Build trust with target audience</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Professional & continious digital presence</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>
                    
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Continious visibility reviews & ratings to enable growth</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Upload Pictures & Videos</td>
                        <td class="second-row">3 Free</td>
                        <td class="third-row">Upto 15</td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Direct email & message interaction for parent enqruires/ Feedback</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr> 
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Featured in Trending Now.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Collaborative social media supportives - as and when</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Verified & Supported partner stamp </td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Post your ad in your School landing page</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                   
                    <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Immediate updates for Leads /enquiries @ BeWise platform</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Benchmark your organisation with your choice of peers / competitors</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Build thought leadership and enhance your brand value.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Ads & newsletter promotion @ special prices</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Free benefits upto INR 50K + for you & your customers</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Scope for collaborative & customised services to drive growth</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Multiple benefits @ WiseConnect, our Talent Management support.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">You get data & analytics to help / accelerate growth</td>
                        <td class="second-row">Partly Free</td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Easy access to Skill building and self-development for all in team</td>
                        <td class="second-row">Partly Free</td>
                        <td class="third-row"><span class="fa fa-check"></span></td>
                        
                    </tr>

                   
                    <tr class="pricing-table-box-list">
                        <td class="first-row"></td>
                        <td colspan="2" class="third-row">
                            <div class="pricing-table-box-item-purchase">
                              <a href="/institution_signup"  class="btn blue-btn">SIGN UP</a>
                            </div>
                        </td>
                       
                    </tr>
                </tbody>
            </table>



              </div>

              {this.state.clickedfromwc && 
              <div id="wiseconnectpricing">
              <div class="dashboardheader">WiseConnect Pricing</div>

              <div class="planbox">

              <table class="pricing-table-box">
                <tbody>
                    <tr>
                        <td width="40%" class="pricing-table-box-text">
                            <h2>All Institutions</h2>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head color2">
                                    <p>WiseConnect + BeWise</p>
                                </div>
                                
                            </div>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head bewisemagic">
                                    <p>WiseConnect Exclusive</p>

                                </div>
                                

                            </div>
                        </td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Initial Sign Up</td>
                        <td class="second-row">Free</td>
                        <td class="third-row">Free - Restricted access*</td>
                        
                    </tr>
                    
                        <tr class="pricing-table-box-list">
                        <td class="first-row">All benefits @ BeWise to enable growth</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">NA</td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">Instant Talent Search @ Portal & reach candidates</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Post Jobs & receive applications @ Portal</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Full access to Courses / Products / articles @ Portal</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Complete access to curated benefits from Partners</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Available data analytics, reports & benchmarks.</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Downloading of candidate CV** @ WiseConnect</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr> 


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Private & direct interaction with candidates / applications</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Ads & newsletter promotion on WiseConnect @ special prices</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Advisory services in WiseConnect @ special prices</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                        
                    </tr>
                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Launch special - No additional or retainer fee on hiring @ WiseConnect</td>
                        <td class="second-row">Yes</td>
                        <td class="third-row">Yes</td>
                    </tr>

                    <tr><td colspan3>&nbsp;</td></tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)</td>
                        <td class="second-row" id="showPrice1"><button class="btn btn-primary btn-sm" onClick={this.showPrice1}>View Pricing</button></td>
                        <td class="third-row" id="showPrice2"><button class="btn btn-primary btn-sm" onClick={this.showPrice2}>View Pricing</button></td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                        <td class="second-row">Billed Annually</td>
                        <td class="third-row">Billed Half yearly</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                        <td class="second-row">3 Months Free with 1st subscription</td>
                        <td class="third-row">NIL</td>
                        
                    </tr>
                                      
                    <tr class="pricing-table-box-list">
                        <td class="first-row"></td>
                        <td class="second-row" colspan="2"> 
                            <div class="pricing-table-box-item-purchase">
                              <a href="/wc_signup"  class="btn blue-btn">Sign Up</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
              </table>

              <div class="smallnotes">To explore collaboration & other enquiries - please connect @ contact@bewise.in</div>

              <div class="help floatright">
                    <ul>
                        <li>* Restricted Access is for 2 weeks with limited visiblity on portal</li>
                        <li>** Limited downloads for non educational instiutions</li>
                        <li>*** Current offer & subject to change with immediate notice</li>      
                    </ul>
              </div>   


              </div>

              </div>
              }
             
            </div>

            <div class="howtobesection">

              <div class="planheader">How to be BeWise Partner?</div>

              <div class="stepbox">

                <ol>
                  <li className="step1clr">
                    <p class="event-date"><img src={step1} /></p>
                    <p class="event-step">Step 1</p>
                    <p class="event-description">Click on Sign Up and provide us with required details to partner with BeWise.</p>
                  </li>
                  <li className="step2clr">
                    <p class="event-date"><img src={step2} /></p>
                    <p class="event-step">Step 2</p>
                    <p class="event-description">Select a Package suitable to your work. Speak to our assigned Sales Team for any support required.</p>
                  </li>
                  <li className="step3clr">
                    <p class="event-date"><img src={step3} /></p>
                    <p class="event-step">Step 3</p>
                    <p class="event-description">BeWise team will Verify and Validate the details provided.</p>
                  </li>
                  <li className="step4clr">
                    <p class="event-date"><img src={step4} /></p>
                    <p class="event-step">Step 4</p>
                    <p class="event-description">Access you Account page to input any additional information. Also, Add Branches if you have</p>
                  </li>
                </ol>

              </div>

            </div>

            <div class="dashboardsection">

              <div class="dashboardheader">Dashboards and Partner Account Page - Sample Views </div>

              <div class="dashboardbox" id="dashboards">

                <Slider {...settings_dashboards} ref={this.slideCustom2}>

                  <div className="dashboardsampleview">
                    <img src={sampleview1} />
                  </div>

                  <div className="dashboardsampleview">
                    <img src={sampleview2} />
                  </div>

                  <div className="dashboardsampleview">
                    <img src={sampleview3} />
                  </div>


                </Slider>
              </div>

            </div>
          </div>
          <div class="col-lg-2 col-sm-2 col-md-2">



          </div>
        </div>
      
        <Footer />
        </React.Fragment >
    );
  }
}

export default PlanPageSchools;



// WEBPACK FOOTER //
// ./src/components/LandingPages/plans_schoolspreschools.jsx